import { Grid } from '@mui/material'
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker'
import { useTranslation } from 'react-i18next'
import { IOffer } from '../../../models/offers'
import { Dispatch, SetStateAction } from 'react'
import dayjs, { Dayjs } from 'dayjs'

interface OffersModalAddonsTabProps {
  offerState: IOffer
  setOfferState: Dispatch<SetStateAction<IOffer>>
}

const OffersModalAddonsTab = ({ offerState, setOfferState }: OffersModalAddonsTabProps) => {
  const { t } = useTranslation(['global'])

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={6}>
        <DateTimePicker
          label={t('start-date')}
          value={offerState.date_ini ? dayjs(offerState.date_ini) : null}
          onChange={(newValue: Dayjs | null) => {
            setOfferState(prev => ({
              ...prev,
              date_ini: newValue
            }))
          }}
          slotProps={{
            textField: {
              fullWidth: true,
              variant: 'filled',
              InputLabelProps: { shrink: true }
            }
          }}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <DateTimePicker
          label={t('end-date')}
          value={offerState.date_end ? dayjs(offerState.date_end) : null}
          onChange={(newValue: Dayjs | null) => {
            setOfferState(prev => ({
              ...prev,
              date_end: newValue
            }))
          }}
          slotProps={{
            textField: {
              fullWidth: true,
              variant: 'filled',
              InputLabelProps: { shrink: true }
            }
          }}
        />
      </Grid>
    </Grid>
  )
}

export default OffersModalAddonsTab
